import React from "react";

import { ReporteContext } from "../../Context/reporteContext";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Tooltip,
} from "@chakra-ui/react";

import { fechaAmigable, fechaCorta } from "../../Services/UltilsService";

const Results = () => {
  //
  const { hidePanel, rows } = React.useContext(ReporteContext);

  const getObj = (obj) => (parseInt(obj) === 0 ? `-OBJ:${obj}` : "");

  const withToolTip = (label, content) => (
    <Tooltip label={label}>{content}</Tooltip>
  );
  if (hidePanel) return null;

  // Lo que debe mostrar la tabla es el nombre del alumno, la fecha de pago, el acuerdo y el alias del curso.
  return (
    <Box
      borderRadius="lg"
      bgColor="white"
      shadow="lg"
      mt="2vh !important"
      width="auto"
    >
      <Box p={4} overflowX="auto">
        <Table variant="striped" colorScheme="gray" size="sm">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Fecha pago</Th>
              <Th>Vendedor</Th>
              <Th>Alumno</Th>
              <Th>Acuerdo</Th>
              <Th>Curso</Th>
              <Th>Estado Pago</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows?.length === 0 || rows?.rows?.length === 0 ? (
              <Tr>
                <Td colSpan={14} textAlign="center">
                  No hay resultados para los filtros seleccionados
                </Td>
              </Tr>
            ) : (rows?.map((row, i) => {
              return (
                <Tr>
                  <Td>{i + 1}</Td>

                  <Td _hover={{ cursor: "pointer" }}>
                    {withToolTip(
                      fechaAmigable(row.fechaInicio),
                      fechaCorta(fechaAmigable(row.fechaInicio))
                    )}
                  </Td>
                  <Td>
                    {row.operador}
                    {getObj(row.objMensual)}
                  </Td>
                  <Td>{row.nombreAlumno}</Td>
                  <Td>${row.acuerdo}</Td>

                  <Td>{withToolTip(row.nombreCurso, row.codigo)}</Td>

                  <Td>{row.descripcionEstado}</Td>
                </Tr>
              );
            }))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default Results;
